import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useRef } from "preact/hooks";
import { FulfillmentSettingsTracking, GeolocationTracking, t, translate, } from "restaumatic-client";
import PreactModal, { ModalHeader } from "../../components/PreactModal";
import RestaurantDeliveryAddressWarning from "../../components/RestaurantDeliveryAddressWarning";
import { hideModal, showModal } from "../../utils/Modals";
import FulfillmentAddressModal from "./FulfillmentAddressModal";
import FulfillmentMethodSwitcher from "./FulfillmentMethodSwitcher";
import FulfillmentTimeModal from "./FulfillmentTimeModal";
export const FULFILLMENT_ADDRESS_MODAL_ID = "fulfillment-address";
const RESTAURANT_INFO_MODAL_ID = "restaurant-info";
function FulfillmentSettings(props) {
    const { restaurantName, orderDetails, methodOptions, methodController, fulfillmentTime, deliveryAddressCoordinator, isCartOpen, onChangeRestaurant, onContactRestaurant, } = props;
    const isTimeButtonVisible = fulfillmentTime.isVisible && fulfillmentTime.isEditable;
    const address = [
        orderDetails.formattedAddress.firstLine,
        orderDetails.formattedAddress.secondLine,
    ]
        .filter((v) => Boolean(v))
        .join(", ");
    return (h(Fragment, null,
        h("article", { id: "fulfillment-settings", class: `m-fulfillment-widget ${!isTimeButtonVisible ? "m-fulfillment-widget--no-time-btn" : ""}` },
            h("div", { class: "m-fulfillment-widget__method" }, methodOptions.length === 1 ? (h(AddressButton, { isDelivery: orderDetails.isDelivery, isSingleFulfillmentMethod: true, singleBtnText: methodOptions[0].label, restaurantName: restaurantName, address: address, deliveryAddressCoordinator: deliveryAddressCoordinator, onContactRestaurant: onContactRestaurant })) : (h(FulfillmentMethodSwitcher, { options: methodOptions, controller: methodController.fields.fulfillmentMethod, 
                // NOTICE: This is a HACK to prevent focusing to the switcher (and as effect: auto scroll to the input) when the Cart modal is opened and value has been changed there
                // TODO: Try to remove it when the fulfillment method is not changed immediately on the same page (in the Cart), but only after the "Save" button is clicked (related to: B2C-256).
                isDisabled: isCartOpen }))),
            h("div", { className: "m-fulfillment-widget__address d-flex" },
                h(AddressButton, { isDelivery: orderDetails.isDelivery, isSingleFulfillmentMethod: false, restaurantName: restaurantName, address: address, deliveryAddressCoordinator: deliveryAddressCoordinator, onContactRestaurant: onContactRestaurant })),
            isTimeButtonVisible && (h("div", { className: "m-fulfillment-widget__time d-flex" },
                h(TimeButton, { fulfillmentTime: fulfillmentTime })))),
        orderDetails.isDelivery && (h(RestaurantDeliveryAddressWarning, { state: orderDetails.deliveryAddressStatus, onChangeRestaurant: onChangeRestaurant }))));
}
const AddressButton = observer((props) => {
    const { isDelivery, isSingleFulfillmentMethod, singleBtnText, restaurantName, address, deliveryAddressCoordinator, onContactRestaurant, } = props;
    const { deliveryAddressController: controller } = deliveryAddressCoordinator;
    const addressBtnRef = useRef(null);
    const handleOpen = () => {
        var _a;
        // Find currently focused element to restore focus after interrupting user interaction
        const currentlyFocusedElement = (_a = document.activeElement) !== null && _a !== void 0 ? _a : undefined;
        void showModal(isDelivery ? FULFILLMENT_ADDRESS_MODAL_ID : RESTAURANT_INFO_MODAL_ID, currentlyFocusedElement);
    };
    const handleSubmitAddress = () => {
        void deliveryAddressCoordinator
            .validateAndSave()
            .then((succeed) => {
            if (succeed) {
                void hideModal(FULFILLMENT_ADDRESS_MODAL_ID);
            }
            FulfillmentSettingsTracking.chooseAddressEvent({ tag: "Menu" });
            GeolocationTracking.findAddressEvent("FulfillmentSettings", controller.validationStatus, controller.streetAddress);
        });
    };
    const btnLabel = isDelivery
        ? translate(t.order.delivery_address)
        : translate(t.orders.order_summary.address);
    return (h(Fragment, null,
        isSingleFulfillmentMethod ? (h("button", { type: "button", ref: addressBtnRef, class: "btn btn-primary u-full-width u-full-height", "aria-label": btnLabel, onClick: handleOpen }, singleBtnText)) : (h("button", { type: "button", ref: addressBtnRef, class: "m-fulfillment-widget__btn", "aria-label": btnLabel, onClick: handleOpen },
            h("span", { class: "m-fulfillment-widget__btn-icon icon-location icon-no-margin", "aria-hidden": "true" }),
            h("span", { class: "m-fulfillment-widget__btn-text" }, address || translate(t.delivery_address.enter_address)))),
        h(FulfillmentAddressModal, { id: FULFILLMENT_ADDRESS_MODAL_ID, deliveryAddressCoordinator: deliveryAddressCoordinator, onSubmit: handleSubmitAddress }),
        h(RestaurantModal, { id: RESTAURANT_INFO_MODAL_ID, title: restaurantName, address: address, onContact: onContactRestaurant })));
});
const TimeButton = observer((props) => {
    const { fulfillmentTime } = props;
    const fulfillmentTimeModalId = "menu-time";
    const btnRef = useRef(null);
    const handleOpen = () => {
        void showModal(fulfillmentTimeModalId);
    };
    const handleHidden = () => {
        var _a;
        (_a = btnRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const handleSubmit = () => {
        FulfillmentSettingsTracking.chooseDateEvent({ tag: "Menu" });
    };
    return (h(Fragment, null,
        h("button", { ref: btnRef, onClick: handleOpen, class: "m-fulfillment-widget__btn u-full-width", "aria-label": fulfillmentTime.modal.title, type: "button" },
            h("span", { class: "m-fulfillment-widget__btn-icon icon-time icon-no-margin", "aria-hidden": "true" }),
            h("span", { class: "m-fulfillment-widget__btn-text u-text-capitalize" }, fulfillmentTime.formattedValueShort)),
        h(FulfillmentTimeModal, { id: fulfillmentTimeModalId, dataFieldId: "Menu.fulfillmentTimeModal", modal: fulfillmentTime.modal, onShow: () => fulfillmentTime.touch(), onSubmit: handleSubmit, onHidden: handleHidden })));
});
const RestaurantModal = observer((props) => {
    const { id, title, address, onContact } = props;
    const titleId = `${id}-title`;
    return (h(PreactModal, { id: id, titleId: titleId, modalClass: "modal-dialog--bottomsheet" },
        h(ModalHeader, { titleId: titleId, title: title }),
        h("div", { class: "modal-body" },
            h("p", null, address),
            h("button", { onClick: onContact, class: "btn-link u-text-transform-none u-p0" }, translate(t.theme_defaults.contact.title))),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "button", "data-bs-dismiss": "modal", class: "btn btn-primary btn-block" }, translate(t.theme_defaults.creator.back_to_menu)))));
});
export default observer(FulfillmentSettings);
